import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Button } from 'root/src/client/v2/common/components/ui/button';
import { Select } from 'root/src/client/v2/common/components/ui/select';
import { cn } from 'root/src/client/v2/common/helpers/cn';
const PAGE_SIZE_OPTIONS = [
    { value: '10', label: '10 / page' },
    { value: '25', label: '25 / page' },
    { value: '50', label: '50 / page' },
];
// Shared client-side pagination bar for redesign tables: shown row range + page-size select +
// prev/next (10 / 25 / 50 page sizes). Hides the range text on small screens to stay compact.
export const TablePagination = ({ page, pageCount, pageSize, total, onPageChange, onPageSizeChange, className, showPageSize = true, }) => {
    const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
    const to = typeof total === 'number' ? Math.min(page * pageSize, total) : 0;
    return (<div className={cn('mt-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between', className)}>
			<div className="flex items-center gap-3">
				{typeof total === 'number' && (<span className="hidden text-xs text-muted-foreground sm:inline">
						Showing {from}-{to} of {total}
					</span>)}
				{showPageSize && onPageSizeChange && (<div className="w-[8.5rem]">
						<Select value={String(pageSize)} onValueChange={value => onPageSizeChange(Number(value))} options={PAGE_SIZE_OPTIONS}/>
					</div>)}
			</div>

			<div className="flex items-center gap-2">
				<Button variant="outline" size="icon" onClick={() => onPageChange(page - 1)} disabled={page <= 1} aria-label="Previous page" className="rounded-lg">
					<ChevronLeftIcon sx={{ fontSize: 18 }}/>
				</Button>
				<span className="min-w-[5.5rem] text-center text-xs text-muted-foreground">
					Page {Math.min(page, pageCount)} of {pageCount}
				</span>
				<Button variant="outline" size="icon" onClick={() => onPageChange(page + 1)} disabled={page >= pageCount} aria-label="Next page" className="rounded-lg">
					<ChevronRightIcon sx={{ fontSize: 18 }}/>
				</Button>
			</div>
		</div>);
};
